import React, { forwardRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { showConfirm } from "../../utility/showconfirm";
import { IoMdCheckmark } from "react-icons/io";
import Textbox from "../../components/formcontrols/normal/Texbox";
import { showCustomSwal } from "../../components/customswal/Customswal";

export const RSVP = forwardRef(({ userID, meetingID, curRSVPAction ,GetMeetingDetails,showbottom},ref) => {
  const [rsvp, setRsvp] = useState(curRSVPAction);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
const [remarkError, setRemarkError] = useState(false);
  const openModal = (action) => {
    if (rsvp == action) return;

    setActionType(action);
    setRemarks("");
    setShowModal(true);
  };

  const submitRSVP = async () => {
    if (actionType == "-1" && !remarks.trim()) {
      showConfirm({
        content: "Please enter remarks for RSVP No.",
        hideCancel: true,
      });
      setRemarkError(true)
      return;
    }

    setLoading(true);
 
    const query = `HRApp_Droid_Proc_User_Meeting_RSVPAction_Submit
      @UserID='${userID}',
      @MeetingID='${meetingID}',
      @RSVPActionType='${actionType}',
      @Remarks='${remarks}'`;

    try {
      const resp = await Hexapi({ query, queryArr: [] });
      console.log("RSVP Response:", resp);
if(resp && resp[""] && resp[""][0]){
if(resp && resp[""] && resp[""][0].command == 1){
  setShowModal(false);
 await showConfirm({
    content:resp[""][0].msg,
    hideCancel:true
  }).then(()=>{
    GetMeetingDetails(true)
  setRsvp(actionType);
      setShowModal(false);
  })

}else{
showConfirm({
    content:resp[""][0].msg,
    hideCancel:true
  })
}
}
      
    } catch (err) {
      console.error("RSVP Submit Error:", err);
       if(err.message =="SQL Error occurred"){
            showCustomSwal("error occurred please try again")
          }
    
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
    ref={ref}
      style={{
        display: "flex",
        gap: "10px",
        position: "sticky",
        zIndex: 1,
        bottom: showbottom ? "10px" : "80px",
        margin: "10px",
      }}
    >
      <div style={{ backgroundColor: "#eae1e1", width: "100%", padding: "8px" , borderRadius:"4px"}}>
        <center>
          <p style={{fontWeight:600}}>
              will be attending this meeting?
          </p>
        </center>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <p
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "2px",
              fontWeight: 700,
              color:"red"
            }}
            onClick={() => openModal("-1")}
          >
            No {rsvp == "-1" && <IoMdCheckmark color="red" size={22} />}
          </p>

          <p
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
          fontWeight: 700,
              color:"#4caf50"
            }}
            onClick={() => openModal("1")}
          >
            Yes {rsvp == "1" && <IoMdCheckmark color="#4caf50" size={22} />}
          </p>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Body style={{paddingBottom:"0px"}}>
 <div style={{color:"red", fontWeight:600 , fontSize:""}}>
            {actionType == "1" ? "RSVP Yes" : "RSVP No"}
         </div>
          <p className="colorset mb-3">
            {actionType == "1"
              ? "will be attending this meeting?"
              : "will not be attending this meeting?"}
          </p>
<Textbox
                                            htmlFor={"REMARKS"}
                                            name="remarks"
                                            id="criticalActivity"
                                            placeholder='Enter Remarks'
                                            required={actionType == "-1"} 
                                            value={remarks}
                                            label={"REMARKS"}
                                            labelStyle={{ display: "flex", alignItems: "Center", fontSize: "16px", fontWeight: "600", color: remarkError ? "red" : "#374151" }}
                                            readOnly={false}
                                            onChange={(e) => setRemarks(e.target.value)}
                                        />
        
        </Modal.Body>

        <Modal.Footer  style={{display:"flex", justifyContent:"flex-end" , border:"none", marginTop:"-20px"}}>
         
          <Button variant="primary" onClick={submitRSVP} disabled={loading}>
            {loading ? "Updating..." : "Yes"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
});